/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import SelectionOfRoomManagement from './SelectionOfRoomManagement';
import TableOfRoomManagement from './TableOfRoomManagement';
import store from "../../../components/stores/Store";

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};

class RoomManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "开发商房源管理";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          开发商房源管理
        </Typography>
        <SelectionOfRoomManagement />
        <TableOfRoomManagement />
      </div>
    );
  }
}

const RoomManagement = observer(RoomManagementInner);

RoomManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RoomManagement);